import {
  FlightBooking,
  getDefaultAssistanceInformation,
  getDefaultFlightBooking,
} from '@/lib/flight/flightModel'

import {type AssistanceInformation} from './types'

const assistanceInformationStorage = createJSONStorage<AssistanceInformation>(() => sessionStorage)
export const assistanceInformationAtom = atomWithStorage<AssistanceInformation>(
  'assistanceInformation',
  getDefaultAssistanceInformation(),
  assistanceInformationStorage,
  {
    getOnInit: true,
  },
)

const needAssistanceAtom = focusAtom(assistanceInformationAtom, optic =>
  optic.prop('needAssistance'),
)
const mobilityAssistanceAtom = focusAtom(assistanceInformationAtom, optic =>
  optic.prop('mobilityAssistance'),
)
const mobilityAssistanceTypeAtom = focusAtom(assistanceInformationAtom, optic =>
  optic.prop('mobilityAssistanceType'),
)
const mobilityDeviceAtom = focusAtom(assistanceInformationAtom, optic =>
  optic.prop('mobilityDevice'),
)
const specialAssistanceAtom = focusAtom(assistanceInformationAtom, optic =>
  optic.prop('specialAssistance'),
)
const specialAssistanceTypeAtom = focusAtom(assistanceInformationAtom, optic =>
  optic.prop('specialAssistanceType'),
)
const serviceAnimalAtom = focusAtom(assistanceInformationAtom, optic => optic.prop('serviceAnimal'))
const medicalEquipmentAtom = focusAtom(assistanceInformationAtom, optic =>
  optic.prop('medicalEquipment'),
)
const medicalEquipmentTypeAtom = focusAtom(assistanceInformationAtom, optic =>
  optic.prop('medicalEquipmentType'),
)

export function useNeedAssistance() {
  return useAtom(needAssistanceAtom)
}

export function useMobilityAssistance() {
  return useAtom(mobilityAssistanceAtom)
}

export function useMobilityAssistanceType() {
  return useAtom(mobilityAssistanceTypeAtom)
}

export function useMobilityDevice() {
  return useAtom(mobilityDeviceAtom)
}

export function useSpecialAssistance() {
  return useAtom(specialAssistanceAtom)
}

export function useSpecialAssistanceType() {
  return useAtom(specialAssistanceTypeAtom)
}

export function useServiceAnimal() {
  return useAtom(serviceAnimalAtom)
}

export function useMedicalEquipment() {
  return useAtom(medicalEquipmentAtom)
}

export function useMedicalEquipmentType() {
  return useAtom(medicalEquipmentTypeAtom)
}

const passengersAndContactStorage = createJSONStorage<FlightBooking>(() => sessionStorage)
export const passengersAndContactAtom = atomWithStorage<FlightBooking>(
  'passengersAndContact',
  getDefaultFlightBooking(),
  passengersAndContactStorage,
  {
    getOnInit: true,
  },
)

export function usePassengersAndContact() {
  return useAtom(passengersAndContactAtom)
}

export function useSetPassengersAndContact() {
  return useSetAtom(passengersAndContactAtom)
}
